<template>
  <status-string :class="statusClass" :text="statusText" class="d-inline-flex" />
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import StatusString from '@/core/components/common/StatusString.vue';
import { ContractStatus } from '@/graphql/generated';

const props = defineProps<{
  status: ContractStatus;
  hideText?: boolean;
}>();

const statusClass = toRef(() => ({
  'text-green': props.status === ContractStatus.InProgress,
  'text-blue': props.status === ContractStatus.OnApproval,
  'text-yellow': props.status === ContractStatus.Draft,
}));

const statusText = toRef(() => {
  if (props.hideText) {
    return '';
  }

  switch (props.status) {
    case ContractStatus.InProgress:
      return 'В работе';
    case ContractStatus.OnApproval:
      return 'На рассмотрении';
    case ContractStatus.Draft:
      return 'Требуется настройка';
    default: {
      return 'Закрыт';
    }
  }
});
</script>

<style scoped lang="scss"></style>
